export default "__VITE_ASSET__BpqIp27p__"